/**
 * © [2025] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const HANDLE_ERROR_MESSAGE_RDNR = 'HANDLE_ERROR_MESSAGE_RDNR';
export const GET_REQUEST_DATA_NICHE_REPORT_LIST =
  'GET_REQUEST_DATA_NICHE_REPORT_LIST';
export const DATA_NICHE_REPORT_SCREEN_TAB_DATA =
  'DATA_NICHE_REPORT_SCREEN_TAB_DATA';
